
import { defineComponent, toRaw } from "vue"
import { photosByYear } from "@/utils/gallery"

export default defineComponent({
  data: () => ({
    items: toRaw(photosByYear["2024"]),
  }),
})
